import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Chart from 'chart.js/auto';
import { createPortal } from 'react-dom';

import { truncateString } from '../../helper';
import { datasetColors } from '../../enum';
// import './tooltipPositioners';

function VerticalPercentageStackedBarChart(props) {
  const { labels, datasets, Tooltip } = props;
  const chartRef = useRef();
  const canvasRef = useRef(null);
  const [tooltipModel, setTooltipModel] = useState();

  useEffect(() => {
    if (!canvasRef.current) return;

    chartRef.current?.destroy();
    chartRef.current = new Chart(canvasRef.current, {
      type: 'bar',
      data: {
        labels: labels.map((label) => truncateString(label, 40)),
        datasets: datasets.map((dataset, index) => ({
          ...dataset,
          backgroundColor: datasetColors[index % datasetColors.length],
          borderWidth: 0,
          barThickness: 24,
        })),
      },
      options: {
        aspectRatio: 2.44,
        animation: { duration: 0 },
        plugins: {
          legend: { display: true },
          tooltip: {
            mode: 'index',
            position: 'middle',
            callbacks: {
              label: (item) => `${item.dataset.label}: ${item.formattedValue}%`,
            },
            filter: (datum) => datum.raw !== 0,
            ...(Tooltip && {
              enabled: false,
              external: (context) => setTooltipModel({ ...context.tooltip }),
            }),
          },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { padding: 10, autoSkip: false },
            stacked: true,
          },
          y: {
            stacked: true,
            min: 0,
            max: 100,
            grid: { drawTicks: false },
            border: { display: false },
            ticks: {
              padding: 14,
              autoSkip: false,
              stepSize: 25,
              count: 5,
              // eslint-disable-next-line id-denylist
              callback: (tickValue) => `${tickValue}%`,
            },
          },
        },
      },
      plugins: [
        {
          id: 'legendBottomMargin',
          beforeInit: (chart) => {
            const originalFit = chart.legend.fit;
            // eslint-disable-next-line no-param-reassign
            chart.legend.fit = function newFit() {
              originalFit.call(chart.legend);
              // eslint-disable-next-line react/no-this-in-sfc
              this.height += 15;
            };
          },
        },
      ],
    });
  }, [datasets]);

  return (
    <>
      <canvas className="engage-report-question-charts__canvas" ref={canvasRef} />
      {Tooltip
        ? createPortal(<Tooltip tooltipModel={tooltipModel} canvasRef={canvasRef} />, document.body)
        : null}
    </>
  );
}

VerticalPercentageStackedBarChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  datasets: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(PropTypes.number).isRequired,
      image: PropTypes.string,
    })
  ).isRequired,
  Tooltip: PropTypes.func,
};

VerticalPercentageStackedBarChart.defaultProps = {
  Tooltip: undefined,
};

export default VerticalPercentageStackedBarChart;
